import { useRef, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Upload, ImageOff } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ImageUpload = ({ value, onChange, token }) => {
  const inputRef = useRef(null);
  const [progress, setProgress] = useState(null);

  const upload = async (file) => {
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) return toast.error("Immagine troppo grande (max 5 MB)");
    const form = new FormData();
    form.append("file", file);
    setProgress(0);
    try {
      const { data } = await axios.post(`${API}/admin/uploads`, form, {
        headers: { Authorization: `Bearer ${token}` },
        onUploadProgress: (e) => e.total && setProgress(Math.round((e.loaded / e.total) * 100)),
      });
      onChange(data.url);
      toast.success("Immagine caricata");
    } catch (e) {
      const d = e.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Caricamento non riuscito");
    } finally {
      setProgress(null);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  const src = value && value.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${value}` : value;

  return (
    <div className="grid gap-3 sm:grid-cols-[160px_1fr]" data-testid="image-upload">
      <div className="aspect-[16/10] rounded-xl bg-sand border border-border overflow-hidden flex items-center justify-center text-muted/60">
        {src ? <img src={src} alt="" className="h-full w-full object-cover" data-testid="image-upload-preview" /> : <ImageOff size={22} />}
      </div>
      <div className="space-y-2">
        <input
          type="file"
          accept="image/jpeg,image/png,image/webp,image/gif"
          ref={inputRef}
          data-testid="image-upload-input"
          onChange={(e) => upload(e.target.files?.[0])}
          className="hidden"
        />
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          disabled={progress !== null}
          data-testid="image-upload-button"
          className="inline-flex items-center gap-2 rounded-full border border-pine text-pine px-4 py-2 text-sm font-medium hover:bg-pine hover:text-linen transition-colors disabled:opacity-50"
        >
          <Upload size={14} /> {progress === null ? "Carica dal computer" : `Caricamento ${progress}%`}
        </button>
        {progress !== null && (
          <div className="h-1.5 w-full rounded-full bg-border overflow-hidden"><div className="h-full bg-pine transition-all" style={{ width: `${progress}%` }} /></div>
        )}
        <input
          data-testid="post-editor-image"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-full rounded-xl border border-border bg-white px-4 py-2.5 text-xs font-mono text-ink placeholder:text-muted/60 outline-none focus:border-pine"
          placeholder="…oppure incolla un URL https"
        />
        <p className="text-[11px] text-muted">JPG, PNG, WEBP o GIF fino a 5 MB. L'immagine viene ottimizzata automaticamente (max 1600px).</p>
      </div>
    </div>
  );
};
